module.exports = __webpack_public_path__ + "img/heart_high.607a1941.png";